export const EXTENDED_PREFERENCES_FIELD_TYPES = {
	FREE_TEXT_FIELD: 1,
	DROPDOWN_FIELD: 2,
	MULTI_SELECT_DROPDOWN_FIELD: 3
}

export const RESERVED_EXTENDED_PREFERENCE_KEYS = {
	AGENT_USERNAME: -1,
	AGENT_USER_ID: -2
}

export const RESERVED_EXTENDED_PREFERENCE_LABELS = {
	AGENT_USERNAME: 'Submitted by CS Agent Username',
	AGENT_USER_ID: 'Submitted by CS Agent User ID'
}
